import React, { useEffect, useRef, useState } from 'react';
import { Clock } from 'lucide-react';
import { ANIMATION_TIMINGS } from '../utils/constants';

const Roulette = ({ gameState, participants, countdown, winner }) => {
  const [spinPosition, setSpinPosition] = useState(0);
  const animationRef = useRef(null);
  const isSpinning = gameState?.status === 'spinning';

  useEffect(() => {
    if (isSpinning && participants.length > 0) {
      let startTime = Date.now();
      
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = elapsed / ANIMATION_TIMINGS.TOTAL_DURATION;
        
        let speed;
        if (progress < 0.45) {
          // 0-5 sec: fast acceleration
          speed = progress * 100;
        } else if (progress < 0.73) {
          // 5-8 sec: slight deceleration
          speed = 45 - (progress - 0.45) * 20;
        } else {
          // 8-11 sec: smooth deceleration
          speed = 30 * (1 - ((progress - 0.73) / 0.27));
        }
        
        setSpinPosition(prev => prev + speed);
        
        if (elapsed < ANIMATION_TIMINGS.TOTAL_DURATION) {
          animationRef.current = requestAnimationFrame(animate);
        }
      };
      
      animate();
      
      return () => {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
      };
    } else if (!isSpinning) {
      setSpinPosition(0);
    }
  }, [isSpinning, participants]);

  const formatTime = (seconds) => {
    if (!seconds) return '2:00';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="px-4 mb-4">
      <div 
        className="relative bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl overflow-hidden"
        style={{ height: '120px' }}
      >
        {!isSpinning ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
              {countdown !== null ? (
                <div className="text-2xl font-bold">{formatTime(countdown)}</div>
              ) : (
                <Clock className="w-10 h-10" />
              )}
            </div>
          </div>
        ) : (
          <div 
            className="absolute inset-0 flex items-center"
            style={{ 
              transform: `translateX(-${spinPosition % (participants.length * 80)}px)`,
            }}
          >
            {[...Array(20)].map((_, i) => (
              <div key={i} className="flex">
                {participants.map((p, idx) => (
                  <div 
                    key={`${i}-${idx}`} 
                    className="w-20 h-20 mx-2 flex items-center justify-center"
                  >
                    <div className={`w-16 h-16 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center text-3xl transition-all ${
                      winner && p.userId === winner.userId ? 'ring-4 ring-yellow-400 scale-110' : ''
                    }`}>
                      {p.avatar || '👤'}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
        
        {/* Center indicator line */}
        <div className="absolute top-0 bottom-0 left-1/2 w-1 bg-yellow-400 transform -translate-x-1/2 z-10"></div>
      </div>
    </div>
  );
};

export default Roulette;